import { getApi } from "@beeldit/core/helpers/api";

async function index(endpoint: string, filterPath: string = "") {
  return await getApi().get(`/${endpoint}?${filterPath}`);
}

export default index;
